// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"ModalBody_modalBody__2-ycd","hasVerticalScrollbar":"ModalBody_hasVerticalScrollbar__26AQL"};